export default "__VITE_ASSET__CIJF$m7V__"